"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _reactRouter = require("react-router");
var routeHighlightChecker = function routeHighlightChecker(route) {
  if (typeof window === "undefined") {
    return false;
  }
  if (route.children) {
    var matchedRoute = route.children.find(function (childRoute) {
      return (0, _reactRouter.matchPath)(window.location.pathname, {
        path: childRoute.path,
        exact: true,
        strict: false
      });
    });
    if (matchedRoute) {
      return true;
    }
  }
  if (route.highlightPaths) {
    var _matchedRoute = route.highlightPaths.find(function (path) {
      return (0, _reactRouter.matchPath)(window.location.pathname, {
        path: path,
        exact: true,
        strict: false
      });
    });
    if (_matchedRoute) {
      return true;
    }
  }
  return (0, _reactRouter.matchPath)(window.location.pathname, {
    path: route.path,
    exact: true,
    strict: false
  });
};
var _default = exports["default"] = routeHighlightChecker;